import { CadesCertificate } from 'cryptopro-cadesplugin-gnivc';
import * as DateFNS from "date-fns";

export class ParsedCadesCertificate
{
	private cert: CadesCertificate;
	public constructor(cert: CadesCertificate)
	{
		this.cert = cert;
		this.Thumbprint = cert.Thumbprint;
		this.ValidFromDate = cert.ValidFromDate;
		this.ValidToDate = cert.ValidToDate;
		this.Subject = this.parseDN(cert.SubjectName);
		this.SubjectName = cert.SubjectName;
		this.Issuer = this.parseDN(cert.IssuerName);
		this.IssuerName = cert.IssuerName;
		this.HasPrivateKey = cert.HasPrivateKey;
		this.PublicKey_Algorithm_FriendlyName = cert.PublicKey_Algorithm_FriendlyName;
		this.PublicKey_Algorithm_OID = cert.PublicKey_Algorithm_OID;
		this.Base64String = cert.Base64String;

		if (DateFNS.isFuture(this.ValidFromDate))
		{
			this.IsAlmostValid = false;
			this.AlmostValidMessage = "Срок действия сертификата еще не начался";
			return;
		}

		if (DateFNS.isPast(this.ValidToDate))
		{
			this.IsAlmostValid = false;
			this.AlmostValidMessage = "Срок действия сертификата закончился";
			return;
		}

		if (!this.HasPrivateKey)
		{
			this.IsAlmostValid = false;
			this.AlmostValidMessage = "Для этого сертификата отсутствует привязанный закрытый ключ";
			return;
		}

		if ((this.PublicKey_Algorithm_OID !== "1.2.643.7.1.1.1.1") && (this.PublicKey_Algorithm_OID !== "1.2.643.7.1.1.1.2"))
		{
			this.IsAlmostValid = false;
			this.AlmostValidMessage = "Данный сертификат не является квалифицированным";
			return;
		}

		this.IsAlmostValid = true;
		this.AlmostValidMessage = "";
	}
	public Thumbprint: string;
	public ValidFromDate: Date;
	public ValidToDate: Date;
	public Subject: Map<string,string>;
	public SubjectName: string;
	public Issuer: Map<string, string>;
	public IssuerName: string;
	public HasPrivateKey: boolean;
	public PublicKey_Algorithm_FriendlyName: string;
	public PublicKey_Algorithm_OID: string;
	public Base64String: string;
	public IsAlmostValid: boolean;
	public AlmostValidMessage: string;

	private parseDN(dn: string): Map<string, string>
	{
		var i = 0;
		var RetVal = new Map<string, string>();
		var name = "";
		var temp = "";
		var quote = false;
		while (i < dn.length)
		{
			if (dn[i] === '"')
			{
				if (quote)
				{
					quote = false;
					i++;
					continue;
				}
				else
				{
					quote = true;
					i++;
					continue;
				}
			}

			if (dn[i] === '=')
			{
				name = temp.trim();
				temp = "";
				i++;
				continue;
			}

			if (dn[i] === ',' && quote === false)
			{
				RetVal.set(name, temp.trim());
				name = "";
				temp = "";
				i++;
				continue;
			}

			temp += dn[i];
			i++;
		}
		if (name !== "" && temp !== "") RetVal.set(name, temp.trim());
		return RetVal;
	};
}



